import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('./components/home/HomePage.vue'),
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('./components/admin/AdminDashboard.vue'),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('./components/dashboard/DashboardPage.vue'),
  },
  {
    path: '/events',
    name: 'events',
    component: () => import('./components/events/EventsPage.vue'),
  },
  {
    path: '/leaderboards',
    name: 'leaderboards',
    component: () => import('./components/leaderboards/LeaderboardsPage.vue'),
  },
  {
    path: '/player/:name',
    name: 'player',
    component: () => import('./components/leaderboards/PlayerProfile.vue'),
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) return savedPosition
    return { top: 0 }
  },
})
